import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useEffect, useState } from "react";
import { getPdfDownloadUrl } from "../../services/firebase/storage";
import { datoCmsId } from "../../services/dato-cms";
import ArticleToolbar from "./toolbar";
import ArticleAuthorInfo from "./author-info";
import { StatusType } from "../../services/firebase/auth-context/reducer";
import { setBookmarked } from "../../services/firebase/bookmarks";
import LoginPopup from "../common/login-popup";
import { accessByMail, hasActiveSubscription } from "../../util/subscription/access";
import { useAnalytics } from "../../hooks/use-ga";
var ContentSidebar = function ContentSidebar(_ref) {
    var authContext = _ref.authContext, ipBased = _ref.ipBased, article = _ref.article, audioStatus = _ref.audioStatus, withSpotlight = _ref.withSpotlight, _ref$showIcons = _ref.showIcons, showIcons = _ref$showIcons === void 0 ? true : _ref$showIcons, _ref$showAuthorInfo = _ref.showAuthorInfo, showAuthorInfo = _ref$showAuthorInfo === void 0 ? true : _ref$showAuthorInfo, book = _ref.book, _ref$typeSlug = _ref.typeSlug, typeSlug = _ref$typeSlug === void 0 ? null : _ref$typeSlug;
    var _authContext$ = authContext[0], authenticated = _authContext$.authenticated, user = _authContext$.user, userData = _authContext$.userData, userClaims = _authContext$.userClaims;
    var _hasActiveSubscription = hasActiveSubscription(userClaims) || accessByMail(user === null || user === void 0 ? void 0 : user.email);
    var _useState = useState({
        status: "LOADING"
    }), pdfStatus = _useState[0], setPdfStatus = _useState[1];
    var _useState2 = useState(null), alertMode = _useState2[0], setAlertMode = _useState2[1];
    var _useState3 = useState(false), loginPopupStatus = _useState3[0], setPopupStatus = _useState3[1];
    var openLoginPopup = function openLoginPopup(mode) {
        setAlertMode(mode);
        setPopupStatus(true);
    };
    var _useAnalytics = useAnalytics(), trackBookmark = _useAnalytics.trackBookmark, trackPdfDownload = _useAnalytics.trackPdfDownload;
    var bookmarked = authenticated && userData.status === StatusType.SUCCESS && userData.data && userData.data.bookmarks && userData.data.bookmarks.includes(article.id);
    var onBookmarkClicked = function onBookmarkClicked() {
        if (authenticated) {
            trackBookmark(article.id, !bookmarked);
            setBookmarked(article.id, !bookmarked, authContext);
        }
        else {
            setAlertMode("LOGIN_REQUIRED");
            setPopupStatus(true);
        }
    };
    useEffect(function () {
        // TODO Only load if subscriber
        if (_hasActiveSubscription || ipBased) {
            loadPdfUrl();
        }
        else {
            setPdfStatus({
                status: "SUBSCRIPTION_REQUIRED"
            });
        }
    }, [_hasActiveSubscription, ipBased]);
    var loadPdfUrl = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
            var downloadUrl;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return getPdfDownloadUrl(datoCmsId(article.id), article.slug);
                        case 3:
                            downloadUrl = _context.sent;
                            setPdfStatus({
                                status: "AVAILABLE",
                                url: downloadUrl
                            });
                            _context.next = 11;
                            break;
                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](0);
                            console.error("Pdf not available: " + _context.t0.message);
                            setPdfStatus({
                                status: "ERROR",
                                message: _context.t0.message
                            });
                        case 11:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, null, [[0, 7]]);
        }));
        return function loadPdfUrl() {
            return _ref2.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement("div", {
        className: "content-sidebar mt-0"
    }, /*#__PURE__*/ React.createElement(ArticleToolbar, {
        onBookmarkClicked: onBookmarkClicked,
        bookmarked: bookmarked,
        pdfStatus: pdfStatus,
        audioStatus: audioStatus,
        openModal: openLoginPopup,
        withSpotlight: withSpotlight,
        article: article,
        slug: "" + (typeSlug ? typeSlug + "/" : "") + article.slug,
        className: "lg:flex"
    }), showAuthorInfo && /*#__PURE__*/ React.createElement(ArticleAuthorInfo, {
        authors: article.authors,
        book: book
    }), /*#__PURE__*/ React.createElement(LoginPopup, {
        shouldShowPopup: loginPopupStatus,
        alertMsg: {
            status: true,
            mode: alertMode
        },
        onClose: function onClose() {
            return setPopupStatus(false);
        }
    }));
};
export default ContentSidebar;
